import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  public sidenavClosed$ = new BehaviorSubject<boolean>(false);


  constructor() { }

  getSidenavClosed(): Observable<boolean> {
    return this.sidenavClosed$.asObservable();
  }

  toggleSidenav(value:boolean): void {
    this.sidenavClosed$.next(value);
  }
  // toggleSidenav(): void {
  //   this.sidenavClosed$.next(!this.sidenavClosed$.value);

  // }
}
